import { Alert, Button, Input, message } from '@drip/drip-design';
import React, { useEffect, useRef, useState, useMemo } from 'react';
import apis from '@/apis/goodsPool';
import './index.less';
import { Search20 } from '@drip/drip-design-icons';
import { Modal } from '@drip/drip-design';
import { debounce } from 'lodash';
import CategoryInventoryTable from '@/pages/activity-manage/merchants/detail/components/category-hp/components/category-inventory-table';

function HpAlert(props) {
  const { activityId, hasThresholdRule, needReceiveNum, needDeleteNum, refreshBlock, goSetRule, log_sense_id } = props;

  return (
    <div className="category-hp-alert">
      {!hasThresholdRule ? (
        <Alert
          type="info"
          showIcon
          message={
            '请设置门槛规则，这样将会有符合场域门槛规则的货盘进行推送~  或 直接接收名下拥有权限的类目货盘（货盘可能较多哦～）'
          }
          action={
            <span>
              <a
                onClick={() => {
                  window.log('yx_center', 'set_threshold', activityId);
                  goSetRule();
                }}
              >
                去设置
              </a>
              {needReceiveNum > 0 ? (
                <span style={{ marginLeft: 10 }}>
                  <OperateModal
                    text="一键接收"
                    type={1}
                    activityId={activityId}
                    refreshBlock={refreshBlock}
                    totalCount={needReceiveNum}
                    log_sense_id={log_sense_id}
                  />
                </span>
              ) : null}
            </span>
          }
        />
      ) : (
        <>
          {needReceiveNum > 0 && (
            <Alert
              style={{ marginBottom: needDeleteNum > 0 ? 8 : 0 }}
              type="info"
              showIcon
              message={`有 ${needReceiveNum} 个符合门槛规则的货盘，请确认是否接收～`}
              action={
                <OperateModal
                  text="去确认"
                  type={1}
                  activityId={activityId}
                  refreshBlock={refreshBlock}
                  totalCount={needReceiveNum}
                  log_sense_id={log_sense_id}
                />
              }
            />
          )}
          {needDeleteNum > 0 && (
            <Alert
              type="info"
              showIcon
              message={`检测到有 ${needDeleteNum} 个货盘不满足场域门槛规则，建议可以移除哦~`}
              action={
                <OperateModal
                  text="去确认"
                  type={3}
                  activityId={activityId}
                  refreshBlock={refreshBlock}
                  totalCount={needDeleteNum}
                  log_sense_id={log_sense_id}
                />
              }
            />
          )}
        </>
      )}
    </div>
  );
}

export default HpAlert;

function OperateModal(props) {
  const { text, type, activityId, refreshBlock, totalCount, log_sense_id } = props;
  const [searchField, setSearchField] = useState('');
  const [visible, setVisible] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const tableRef = useRef(null);
  const btnDisabled = useMemo(() => !selectedRowKeys.length, [selectedRowKeys]);

  const [loading, setLoading] = useState(false);

  // 搜索框防抖
  const changeInputVal = debounce((value) => {
    setSearchField(value);
  }, 800);

  const onOk = () => {
    setLoading(true);
    apis.inventoryOperate({ activityId, inventoryIds: selectedRowKeys, opt: type === 1 ? 1 : 3 }).then((res) => {
      if (res.ret === '0') {
        if (selectedRowKeys.length >= totalCount) {
          setVisible(false);
        } else {
          tableRef.current.refresh();
        }
        message.success(type === 1 ? '接收成功' : '移除成功');
        refreshBlock();
        setSelectedRowKeys([]);
      } else {
        message.error('操作失败');
      }
      setLoading(false);
    });
  };

  const notAccept = () => {
    setLoading(true);
    apis.inventoryOperate({ activityId, inventoryIds: selectedRowKeys, opt: 2 }).then((res) => {
      if (res.ret === '0') {
        if (selectedRowKeys.length >= totalCount) {
          setVisible(false);
        } else {
          tableRef.current.refresh();
        }
        message.success('驳回成功');
        refreshBlock();
        setSelectedRowKeys([]);
      } else {
        message.error('驳回失败');
      }
      setLoading(false);
    });
  };

  return (
    <>
      <a
        onClick={() => {
          window.log('yx_center', type === 1 ? 'accept_strategy' : 'remove_strategy', activityId, log_sense_id);
          setVisible(true);
        }}
      >
        {text}
      </a>
      <Modal
        width={1200}
        visible={visible}
        title={type == 1 ? '确认新增货盘' : '确认需要移除的货盘'}
        onCancel={() => setVisible(false)}
        className="category-hp-alert-modal"
        footer={[
          type === 1 ? (
            <Button key="cancel" onClick={notAccept} disabled={btnDisabled} loading={loading}>
              驳回
            </Button>
          ) : (
            <Button key="cancel" onClick={() => setVisible(false)}>
              取消
            </Button>
          ),
          <Button key="confirm" onClick={onOk} type="primary" disabled={btnDisabled} loading={loading}>
            确认并{type == 1 ? '新增' : '移除'}
          </Button>,
        ]}
      >
        <div className="modal-top-block">
          <div className="modal-tips">{type == 1 ? '请勾选需要新增的货盘' : '请勾选需要移除的货盘'}</div>
          <Input
            style={{ width: 300 }}
            suffix={<Search20 style={{ color: 'rgba(0, 0, 0, 0.45)' }} />}
            placeholder="请输入货盘名称/创建人erp搜索"
            onChange={(e) => changeInputVal(e.target.value)}
          />
        </div>
        <CategoryInventoryTable
          ref={tableRef}
          activityId={activityId}
          type={type}
          searchField={searchField}
          rowSelection={{
            selectedRowKeys: selectedRowKeys,
            columnWidth: 30,
            onSelect(record, selected, selectedRows, nativeEvent) {
              if (selected) {
                setSelectedRowKeys((row) => row.concat(record.inventoryId));
              } else {
                setSelectedRowKeys((row) => row.filter((item) => item != record.inventoryId));
              }
            },
            onSelectAll(selected, selectedRows, changeRows) {
              const changeKeys = changeRows.reduce((result, current) => {
                result.push(current.inventoryId);
                return result;
              }, []);
              if (selected) {
                setSelectedRowKeys((row) => row.concat(changeKeys));
              } else {
                setSelectedRowKeys((row) => row.filter((item) => changeKeys.indexOf(item) == -1));
              }
            },
          }}
        />
      </Modal>
    </>
  );
}
